import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { buttonTypes } from 'src/app/shared/constants/commonenums';
import { ButtonValue } from 'src/app/shared/dynamicform/models/common-models';
import { GuestService } from 'src/app/shared/services/guest.service';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    standalone: false
})
export class MessageComponent implements OnInit {
  @Output() closeEvent = new EventEmitter();
  primaryButton: ButtonValue;
  secondaryButton: ButtonValue;

  constructor(public gs: GuestService) { }

  @Input() messageInfo: any;
  message: any;


  closeMessage() {
    this.gs.bShowOverbookingErrorDialog = false;
    this.closeEvent.emit();
  }
  ngOnInit(): void {
    this.message = this.messageInfo;
    // if(this.gs.bShowOverbookingErrorDialog) {
    //   this.message.message += ' Are you sure you want to proceed?';
    // }
    this.primaryButton = {
      type: buttonTypes.confirmBtn,
      label: 'Yes',
      customclass: 'guest-details__confirm-btn',
      disbaledproperity: false
    };

    this.secondaryButton = {
      type: buttonTypes.cancelBtn,
      label: 'No',
      customclass: 'guest-details__cancel-btn',
      disbaledproperity: false
    };
  }

  emitOverlapBookingproceedEvent() {
    this.gs.bShowOverbookingErrorDialog = false;
    this.gs.allowOverlapBookings = true;
    this.gs.overlapBookingproceedEvent.next({proceedOverlapBooking: true, isOverlapErrorFromValidateCartApi: this.gs.isOverlapErrorFromValidateCartApi});
    this.closeEvent.emit();
  }

}
